// client/src/components/Post/ReaderModerationBanner/types.ts

export type ModerationStatusEnum = 'PUBLISHED' | 'PENDING_REWRITE' | 'REMOVED';

export type ReaderBannerState =
  | { kind: 'none' }
  | { kind: 'pending_rewrite' }
  | { kind: 'revised' }
  | { kind: 'removed' };

/**
 * Initial banner state for a freshly-mounted component, derived from the
 * post's current moderationStatus from the GraphQL response.
 */
export function initialFor(status: ModerationStatusEnum): ReaderBannerState {
  if (status === 'PENDING_REWRITE') return { kind: 'pending_rewrite' };
  if (status === 'REMOVED') return { kind: 'removed' };
  return { kind: 'none' };
}

/**
 * State transition driven by a WS event. The 'revised' state is only
 * reached when transitioning FROM pending_rewrite TO PUBLISHED — that's
 * the rewrite-republish path.
 */
export function transition(
  prevStatus: ModerationStatusEnum,
  newStatus: ModerationStatusEnum,
): ReaderBannerState {
  if (newStatus === 'PUBLISHED') {
    if (prevStatus === 'PENDING_REWRITE') return { kind: 'revised' };
    return { kind: 'none' };
  }
  if (newStatus === 'PENDING_REWRITE') return { kind: 'pending_rewrite' };
  if (newStatus === 'REMOVED') return { kind: 'removed' };
  return { kind: 'none' };
}
